import script from "./AuctionField.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionField.vue?vue&type=script&setup=true&lang=js"

import "./AuctionField.vue?vue&type=style&index=0&id=2ceff01e&lang=scss"

const __exports__ = script;

export default __exports__